module.exports = __webpack_public_path__ + "img/marketing.a796173f.svg";